









































































import { Vue, Component, Prop } from "vue-property-decorator";
import SocialLinks from "@/components/SocialLinks.vue";
import FooterMenuItem from "@/components/FooterMenuItem.vue";



@Component({
  components: {
    SocialLinks,
    FooterMenuItem,
  },
})
export default class Footer extends Vue {

  menuShown : any = null;

  links1 = [
      { title: 'Chi siamo', url: 'https://bancaprofilo.tinaba.it/chi-siamo' },
      { title: 'Banca Profilo', url: 'https://bancaprofilo.tinaba.it/banca-profilo' },
      { title: 'Lavora con noi', url: 'https://bancaprofilo.tinaba.it/lavora-con-noi' },
      { title: 'Stampa', url: 'https://bancaprofilo.tinaba.it/area-stampa' },
      { title: 'Aiuto', url: 'https://bancaprofilo.tinaba.it/aiuto' },
  ];

  links2 = [
      { title: 'Un mondo di Pay', url: 'https://bancaprofilo.tinaba.it/un-mondo-di-pay' },
      { title: 'Tinaba e Alipay', url: 'https://bancaprofilo.tinaba.it/tinaba-e-alipay' },
      { title: 'Google Pay', url: 'https://bancaprofilo.tinaba.it/google-pay' },
      { title: 'Apple Pay', url: 'https://bancaprofilo.tinaba.it/apple-pay' },
  ]

  links3 = [
      { title: 'Trasparenza', url: 'https://bancaprofilo.tinaba.it/trasparenza' },
      { title: 'Manuale d\'uso', url: 'https://bancaprofilo.tinaba.it/manuale-d-uso' },
      { title: 'E-Commerce', url: 'https://bancaprofilo.tinaba.it/e-commerce' },
      { title: 'Blog', url: 'https://investiamo.tinaba.it' },
  ]

  links4 = [
      { title: 'Documenti legali', url: 'https://bancaprofilo.tinaba.it/documenti-legali' },
      { title: 'Promozioni e regolamenti', url: 'https://bancaprofilo.tinaba.it/promozioni-e-regolamenti' },
      { title: 'Informativa sulla Privacy', url: 'https://bancaprofilo.tinaba.it/privacy-policy' },
      { title: 'Impostazioni cookie', url: 'https://bancaprofilo.tinaba.it/impostazioni-cookie' },
  ]

  setMenuShown(v : String)
  {
    this.menuShown = v
  }

}
